/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { LegalHintsCardFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { LegalHintsCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { legalHintsItemDataMock } from '../LegalHintsItem/mockdata';

export const legalHintsCardDataMock: LegalHintsCardFragmentFragment = {
  legalHints: [legalHintsItemDataMock, legalHintsItemDataMock],
};

export function getLegalHintsCardFragmentedData(data?: LegalHintsCardFragmentFragment) {
  return makeFragmentData(data || legalHintsCardDataMock, LegalHintsCardFragmentFragmentDoc);
}
